import React, { useState } from 'react';
import styles from './AutoRolloutSection.module.css';
import Ico from '../common/Ico';
import Btn from '../common/Btn';
import { setAlert } from '../../helpers/alerts';
import { apiUpdateBranch } from '../../api/branches';

const ICO_ROCKET = 'M12 2c3 3 4 7 4 10 0 3-2 5-4 6-2-1-4-3-4-6 0-3 1-7 4-10zM8 15l-3 5M16 15l3 5';
const ICO_LAYERS = 'm12 2 10 6-10 6L2 8l10-6z M2 16l10 6 10-6 M2 12l10 6 10-6';

export default function AutoRolloutSection({ branch, onEditBuildCandidates, reloadData }) {
  const [saving, setSaving] = useState(false);

  const enabled = !!branch.auto_rollout_enabled;

  const handleToggle = () => {
    setSaving(true);
    apiUpdateBranch(branch.version, { auto_rollout_enabled: !enabled })
      .then(() => { setAlert('Auto-rollout', `Automatic nightly rollout ${enabled ? 'disabled' : 'enabled'} for "${branch.version}"`, 'success'); reloadData?.(); })
      .catch((e) => setAlert('Auto-rollout error', e, 'danger'))
      .finally(() => setSaving(false));
  };

  return (
    <section className={styles.section} id="sec-auto-rollout">
      <div className={styles.text}>
        <span className={styles.iconTile}>
          <Ico d={ICO_ROCKET} size={16} strokeWidth={1.7} />
        </span>
        <div className={styles.copy}>
          <div className={styles.title}>Nightly rollout</div>
          <div className={styles.subtitle}>
            When enabled, successful nightly builds are announced in Slack, wait 15 minutes, then deploy to rollout candidates unless skipped.
          </div>
        </div>
      </div>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.switchControl}
          role="switch"
          aria-checked={enabled}
          aria-label={`${enabled ? 'Disable' : 'Enable'} auto rollout`}
          disabled={saving}
          onClick={handleToggle}
        >
          <span className={styles.switchMeta}>
            <span className={styles.switchText}>Auto rollout</span>
            <span className={enabled ? styles.switchOn : styles.switchOff}>{enabled ? 'On' : 'Off'}</span>
          </span>
          <span className={styles.switchTrack} aria-hidden="true">
            <span className={styles.switchThumb} />
          </span>
        </button>
        <Btn variant="secondary" size="lg" icon={ICO_LAYERS} onClick={onEditBuildCandidates}>
          Edit rollout candidates
        </Btn>
      </div>
    </section>
  );
}
